import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DialogOverlayComponent } from './components/dialog-overlay.component';
import {  MatButtonModule } from '@angular/material/button';

@NgModule({
    declarations: [
        DialogOverlayComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
    ],
    exports: [
        DialogOverlayComponent
    ],
})
export class DialogOverlayModule {
}
